import React from 'react';
import _ from 'lodash';

//ButtonList generates list of color swatch button used in 
//product detail section
const ButtonList = (props) => {
    const groupByColor = _(props.variants)
        .groupBy(x => x.option1)
        .map((value, key) => ({ color: key, details: value }))
        .value();

    let buttonGroups = groupByColor.map(x => {
        return (
            <button key={x.color}
                    onClick={() => props.onButtonClick(x.color)}
                    className='color-swatch-button'>
            </button>
        )
    })

    return (
        <div className='color-swatches'> {buttonGroups} </div>
    )

}

export default ButtonList;


// WEBPACK FOOTER //
// ./src/components/button-list.js